exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectedImg {\n  -webkit-transition: all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms;\n  transition: all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms;\n  border: 1px solid #005BA5 !important;\n}\n.selectedImg p {\n  color: #005BA5;\n  -webkit-transition: all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms;\n  transition: all 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms;\n}", ""]);

// exports
